import { render, staticRenderFns } from "./addFeeCombo.vue?vue&type=template&id=5a18c6c3&scoped=true"
import script from "./addFeeCombo.vue?vue&type=script&lang=js"
export * from "./addFeeCombo.vue?vue&type=script&lang=js"
import style0 from "./addFeeCombo.vue?vue&type=style&index=0&id=5a18c6c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18c6c3",
  null
  
)

export default component.exports